import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-nosotros',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nosotros.html',
  styleUrls: ['./nosotros.css']
})
export class NosotrosComponent {

  valores = [
    { titulo: 'Honestidad', descripcion: 'Actuamos con transparencia, compromiso y confiabilidad en todas nuestras relaciones comerciales con nuestros clientes, proveedores y colaboradores.' },
    { titulo: 'Innovación', descripcion: 'Consideramos la mejora continua y la búsqueda de nuevas soluciones tecnológicas como elementos fundamentales para el desarrollo empresarial sostenible de la organización.' },
    { titulo: 'Excelencia técnica', descripcion: 'Aplicamos la experiencia profesional de cada miembro del equipo para brindar servicios de calidad que superen las expectativas de nuestros clientes.', claseExtra: 'excelencia-tec' }, // Clase opcional si la necesitas
    { titulo: 'Responsabilidad', descripcion: 'Asumimos nuestras responsabilidades con seriedad y compromiso, garantizando el cumplimiento de plazos y estándares de calidad en cada proyecto que desarrollamos.' },
    { titulo: 'Sostenibilidad', descripcion: 'Promovemos el desarrollo sostenible que garantice la preservación del medio ambiente, fomentando buenas prácticas ambientales en todos nuestros proyectos.' },
    { titulo: 'Compromiso', descripcion: 'Nos comprometemos de forma activa con las necesidades de nuestros clientes y el desarrollo del país, manteniendo relaciones de largo plazo basadas en la confianza mutua.' }
  ];

  ventajas = [
    'Experiencia técnica comprobada',
    'Cumplimiento normativo y contractual',
    'Entrega de proyectos dentro del plazo establecido',
    'Seguridad operativa garantizada'
  ];
}